import { BookingFormMode } from "PFApp/booking/components/booking_form/booking_form.types";
import { DetailsPanelType } from "PFApp/booking/components/details_panel/details_panel.types";
import { Id } from "PFCore/types";

export enum SidePanelType {
  ProfilePreview = "profile_preview",
  ActivityPreview = "activity_preview",
  CustomValuePreview = "custom_value_preview",
  BookingDetails = "booking_details_panel",
  ProfileBulkEditSkills = "profile_bulk_edit_skills",
  CustomValueManagement = "custom_value_management",
  CustomValueEdit = "custom_value_edit",
  CustomValueTranslations = "custom_value_translations",
  TargetAllocationDetails = "target_allocation_details",
  TargetAllocationEdit = "target_allocation_edit",
  KPIsReview = "KPIs_review",
  KpiConfiguration = "kpi_configuration",
  CustomTypeCleanupUnused = "custom_type_cleanup_unused",
  ReportVersions = "report_versions",
  SuggestedWm = "suggested_wm"
}

export type BoookingDetailKey = `${SidePanelType.BookingDetails}_${DetailsPanelType}_${Id | BookingFormMode}`;

export type PanelKey = Exclude<SidePanelType, "BookingDetails"> | BoookingDetailKey;

export type PanelItem<T extends object = any> = {
  key: PanelKey;
  data: T;
  index: number;
  isClosing?: boolean;
  isPersistent: boolean; // If true, the panel will stay open even if the user opens a new panel which doesn't stack
  disableEntranceAnimation?: boolean; // If true, the panel entrance animation will be disabled (used when replacing panels of the same type)
};

export type PanelsData<T extends object = any> = {
  panels: PanelItem<T>[];
};

export type PanelsActions<T extends object = any> = {
  openPanel: (
    key: PanelKey,
    data: T,
    stack?: boolean,
    persist?: boolean,
    disableEntranceAnimation?: boolean
  ) => void;
  closePanel: (keyOrSelector: PanelKey | ((panels: PanelItem<T>[]) => PanelItem<T>[])) => void;
  setPanelData: (key: PanelKey, newData: T | ((data: T) => T)) => void;
  updatePanelsData: (type: SidePanelType, newData: T | ((data: T) => T)) => void;
  setPanelIsClosing: (key: PanelKey, isClosing: boolean) => void;
  closeAllPanels: () => void;
};
